import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DownloadFile, Icon, InputWithIcon, TableLoader } from '@livable/saas-react-components';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { useNavigate } from 'react-router-dom';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
export const UtilityBillsTab = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState('all'),
    _useState2 = _slicedToArray(_useState, 2),
    properties = _useState2[0],
    setProperties = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    utilityBillsData = _useState6[0],
    setUtilityBillsData = _useState6[1];
  const handlePropertiesChange = (e, value) => {
    if (value) setProperties(value);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSearchKeyChange = (e, value) => {
    setSearchKey(e.target.value);
  };
  const fetchPropertiesList = async () => {
    const utilityBillsList = [];
    const getCompanyProperties = async () => {
      const resp = await store.company.getCompanyPropertiesAsync.run();
      return resp;
    };
    const getBillsFileCabinet = async data => {
      const resp = await store.allocations.getBillsFileCabinetAsync.run(data);
      return resp;
    };
    const propertyIds = [];
    const propertiesData = await getCompanyProperties();
    if (propertiesData !== null && propertiesData !== void 0 && propertiesData.isSuccessful) {
      propertyIds.push(...propertiesData.response.map(prop => prop.propertyId));
      utilityBillsList.push(...propertiesData.response);
    }
    if (propertyIds.length) {
      const billsData = await getBillsFileCabinet({
        propertyIds
      });
      if (billsData !== null && billsData !== void 0 && billsData.isSuccessful) {
        utilityBillsList.map((item, index) => {
          const matchingProperty = billsData.response.find(i => i.propertyId === item.propertyId);
          utilityBillsList[index] = Object.assign({}, utilityBillsList[index], {
            filesCount: (matchingProperty === null || matchingProperty === void 0 ? void 0 : matchingProperty.filesCount) || 0,
            fileIds: (matchingProperty === null || matchingProperty === void 0 ? void 0 : matchingProperty.fileIds) || []
          });
        });
      }
      setUtilityBillsData(utilityBillsList);
    }
  };
  useEffect(() => {
    try {
      fetchPropertiesList();
    } catch (e) {
      console.log('useEffect Error', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.filtersWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchWrapper
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "charges-search",
    label: t('general.search'),
    variant: "outlined",
    value: searchKey,
    onChange: handleSearchKeyChange,
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: properties,
    onChange: handlePropertiesChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "all"
  }, t('file_cabinet.show_all_properties')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "active"
  }, t('file_cabinet.active_properties')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "inactive"
  }, t('file_cabinet.inactive_properties')))), store.company.getCompanyPropertiesAsync.inProgress || store.allocations.getBillsFileCabinetAsync.inProgress ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "utility bills table",
    type: "fullWidth"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.mainCell
  }, t('file_cabinet.property')), /*#__PURE__*/React.createElement(TableCell, null, t('file_cabinet.bill_files_count')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('file_cabinet.download')))), /*#__PURE__*/React.createElement(TableBody, null, utilityBillsData.filter(i => {
    if (properties === 'active') {
      return i.propertyStatus === PROPERTY_STATUS_ENUM.Active;
    } else if (properties === 'inactive') {
      return i.propertyStatus === PROPERTY_STATUS_ENUM.Inactive;
    } else {
      return true;
    }
  }).filter(i => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(i.propertyAddress).search(searchPhrase) > 0 : true;
  }).map(bill => {
    var _store$fileCabinet$ge;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: bill.propertyId
    }, /*#__PURE__*/React.createElement(TableCell, {
      onClick: () => navigate("/bills_files?id=".concat(bill.propertyId), {
        state: {
          address: bill.propertyAddress
        }
      }),
      className: classes.propertyAddressCell
    }, bill.propertyStatus === PROPERTY_STATUS_ENUM.Active && /*#__PURE__*/React.createElement(Icon, {
      color: "success",
      type: "building"
    }), bill.propertyStatus === PROPERTY_STATUS_ENUM.Inactive && /*#__PURE__*/React.createElement(Icon, {
      color: "grey",
      type: "building-minus"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      className: classes.title
    }, bill.propertyAddress)), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Icon, {
      type: "file-text"
    }), /*#__PURE__*/React.createElement("span", {
      className: classes.amount
    }, bill.filesCount)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(DownloadFile, {
      disabled: bill.filesCount <= 0 || ((_store$fileCabinet$ge = store.fileCabinet.getFilesArchiveAsync) === null || _store$fileCabinet$ge === void 0 ? void 0 : _store$fileCabinet$ge.inProgress),
      fileId: bill.fileIds,
      multiple: true,
      store: store,
      usePreSignedDownload: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled,
      text: "file_cabinet.download_all_files"
    })));
  })))));
});